export default {
  title: 'Studio (V2)',
  description: 'Twórz i zarządzaj stroną restauracji w nowym Website Studio.',
  retry: 'Spróbuj ponownie',
  deleted: 'Projekt został usunięty.',
  errors: {
    load: 'Nie udało się wczytać projektu Studio (V2).',
    create: 'Nie udało się utworzyć projektu. Spróbuj ponownie.',
    delete: 'Nie udało się usunąć projektu. Spróbuj ponownie.',
  },
  EmptyState: {
    title: 'Brak projektu Studio (V2)',
    description: 'Utwórz projekt, aby budować stronę w nowym Website Studio. Studio (V1) pozostaje bez zmian.',
    description_no_access: 'Projekt dla tej marki może utworzyć menedżer ds. wdrożenia.',
    create: 'Utwórz projekt',
  },
  ProjectCard: {
    unnamed: 'Projekt bez nazwy',
    edit: 'Edytuj w Studio',
    delete: 'Usuń',
    open: 'Otwórz',
    no_domain: 'Brak domeny',
    fields: {
      uuid: 'UUID',
      domain: 'Domena',
      websites: 'Strony internetowe',
    },
    delete_confirm: {
      title: 'Usunąć ten projekt?',
      description:
        'Spowoduje to usunięcie projektu Studio (V2) i jego stron internetowych. Nowy projekt możesz utworzyć później.',
      ok: 'Usuń',
      cancel: 'Anuluj',
    },
  },
};
